import React, { useContext, useState } from "react";
import "./SideBar.css";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import NewsComponent from "./NewsComponent";
import Grid from "@material-ui/core/Grid";
import { intelliegenceContext } from "../../../states/context/intelliegenceContext";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const SideBar = () => {
  const context = useContext(intelliegenceContext);
  const news = context.markerLocation.filter(
    (markerInfo) => markerInfo.marker_type === "news"
  );
  const styles = useStyles();
  const [page, SetPageName] = useState(null);

  const onClickNewsBtn = () => {
    const _drawer = context.drawer;
    _drawer.news = !_drawer.news;

    context.setDrawer(_drawer);
  };

  return (
    <div className={styles.root} id="intelligence-sidebar">
      <Grid item xs={3} className={"side-bar-news"}>
        {news.length > 0 && (
          <React.Fragment>
            <Card className="newshead">
              <Grid style={{ display: "flex" }}>
                <Grid item xs={7}>
                  <h3 className={styles.filterText}>News</h3>
                </Grid>
                <Grid item xs={3}>
                  <h3 className={styles.filterText}>
                    {context.drawer.news ? "Hide" : "Show"}
                  </h3>
                </Grid>
                <Grid item xs={2} className={styles.downBtn}>
                  <IconButton
                    aria-label="side"
                    size="small"
                    className={styles.newsDrawer}
                    onClick={onClickNewsBtn}
                  >
                    {context.drawer.news ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowUpIcon />
                    )}
                  </IconButton>
                </Grid>
              </Grid>
            </Card>
            <span className="news-section-medium">
              {context.drawer.news ? (
                <div>
                  <h3 className={styles.filterText}>News</h3>
                  <IconButton
                    aria-label="side"
                    size="small"
                    className={styles.newsDrawer}
                    onClick={onClickNewsBtn}
                  >
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </div>
              ) : (
                <span className="news-section-small">
                  <span className={styles.filterText}>News</span>
                  <IconButton
                    aria-label="side"
                    size="small"
                    className={styles.newsDrawer}
                    onClick={onClickNewsBtn}
                  >
                    <KeyboardArrowRightIcon />
                  </IconButton>
                </span>
              )}
            </span>
            <Card className={`${styles.newsSection} ${
                context.drawer.news ? styles.show : styles.hide
              }`} id="news-section">
              <NewsComponent page={page} />
            </Card>
          </React.Fragment>
        )}
      </Grid>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    maxHeight: "89vh",
  },
  newsSection: {
    borderRadius: "0px",
    marginTop: "8px",
    height: "auto",
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "75vh",
    transition: "transform 0.5s ease-in-out", // Add transition property
  },

  show: {
    transform: "translateX(0)", 
  },
  hide: {
    transform: "translateX(-100%)",
  },
  downBtn: {
    "& .MuiButtonBase-root ": {
      left: "12%",
      marginTop: "2px",
    },
  },
  filterText: {
    margin: "0px",
    fontFSamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "6px 6px 6px 12px",
  },
}));

export default SideBar;
